// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./fonts/rajdhani/rajdhani-latin-ext-300.woff2");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./fonts/rajdhani/rajdhani-latin-ext-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_2___ = require("./fonts/rajdhani/rajdhani-latin-ext-500.woff2");
var ___CSS_LOADER_URL_IMPORT_3___ = require("./fonts/rajdhani/rajdhani-latin-ext-600.woff2");
var ___CSS_LOADER_URL_IMPORT_4___ = require("./fonts/rajdhani/rajdhani-latin-ext-700.woff2");
var ___CSS_LOADER_URL_IMPORT_5___ = require("./fonts/source-sans/source-sans-3-latin-ext-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_6___ = require("./fonts/source-sans/source-sans-3-latin-ext-italic.woff2");
var ___CSS_LOADER_URL_IMPORT_7___ = require("./fonts/source-sans/source-sans-3-latin-ext-700.woff2");
var ___CSS_LOADER_URL_IMPORT_8___ = require("./fonts/source-sans/source-sans-3-latin-ext-700-italic.woff2");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Optional: keep global base font if desired app-wide */
html {
  font-size: 12px;
}

/* Font face declarations */

@font-face {
  font-family: "Rajdhani";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rajdhani";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rajdhani";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rajdhani";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rajdhani";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Source Sans 3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Source Sans 3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
    format("woff2");
  font-weight: 400;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: "Source Sans 3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
    format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Source Sans 3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
    format("woff2");
  font-weight: 700;
  font-style: italic;
  font-display: swap;
}

#gw-map {
  /* Fonts */
  --map-heading-font: "Rajdhani", system-ui, sans-serif;
  --map-body-font: "Source Sans 3", system-ui, sans-serif;

  --map-h1-font-size: clamp(1.25rem, 1.0455rem + 1.0227vw, 3.5rem);
  --map-h2-font-size: clamp(1.5rem, 1.9545rem + 0.2273vw, 2rem);
  --map-h3-font-size: clamp(1.25rem, 1.7273rem + 0.1136vw, 1.5rem);
  --map-body-font-size: clamp(1rem, 0.9545rem + 0.2273vw, 1.5rem);
  --map-small-body-font-size: calc(var(--map-body-font-size) * 0.875);
  --map-sub-body-font-size: calc(var(--map-body-font-size) * 0.75);

  --map-h1-font-weight: 700;
  --map-h2-font-weight: 600;
  --map-h3-font-weight: 400;

  /* Colours */
  --map-h1-color: #060a23;
  --map-h2-color: #060a23;
  --map-h3-color: #333333;
  --map-body-color: #333333;
  --map-body-color-light: #ffffff;
  --map-subtitle-color-light: #cccccc;
  --map-subtitle-color-dark: #666666;

  --map-background-color-light: #eeeffc;
  --map-background-color-dark: #111003;
  --map-accent-color: #00c49a;
  --map-accent-color-dark: #00A380;

  --map-a-color: #102b5e;

  --heading-letter-spacing: 0.05em;

  /* Map floating buttons */
  --map-button-box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);

  /* popups */
  --map-popup-background-color: #eeeffc;
  --map-popup-border: 0.125rem solid #333;
  --map-popup-border-color: #333;
  --map-popup-border-radius: 0.75rem;
  --map-popup-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.25);
  --map-popup-box-shadow-inner: inset 0 0px 5px rgba(0, 0, 0, 0.5);
  --map-popup-content-padding: 0.5rem 1rem 0.625rem 1rem;
  --map-popup-content-padding--scrollable: 0 0 0 0 1rem;

  /* icons */
  --default-icon-color: #333333;
  --map-icon-color-dark: #333333;
  --map-icon-color-light: #cccccc;
  --active-icon-color: #4cbe23;

  /* Animal Status */
  --status-active-color: #4cbe23;
  --status-inactive-color: #ffc60a;
  --status-deactivated-color: #b63e4e;

  /* interactivity */
  --focus-outline: 2px solid #a8bef0;
  --hover-transition-duration: 0.25s;

  /* Decorative elements */
  --border-divider: 3px double rgba(0, 0, 0, 0.15);
  --accent-border: 0.125rem solid var(--map-accent-color);
  --ocean-gradient: linear-gradient(
    135deg,
    #060a23 0%,
    #060a23 75%,
    #0a0e2c 90%,
    #0e1235 100%
  );
}

#gw-map {
  background: #102b5e;
  overflow-y: hidden;
}

#gw-map :where(h1, h2, h3, h4, h5, h6, p) {
  margin: 0;
  line-height: 1.2;
}

#gw-map h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--map-heading-font);
  letter-spacing: var(--heading-letter-spacing);
}

#gw-map .map-heading {
  font-family: var(--map-heading-font);
}

#gw-map h1.mapTitle {
  font-family: var(--map-heading-font);
  font-size: var(--map-h1-font-size);
  letter-spacing: var(--heading-letter-spacing);
  font-weight: var(--map-h1-font-weight);
  margin-bottom: 0.5rem;
}

#gw-map h1.map-heading {
  font-size: var(--map-h1-font-size);
  font-weight: var(--map-h1-font-weight);
  letter-spacing: var(--heading-letter-spacing);
  color: var(--map-h1-color);
}

#gw-map h2.map-heading {
  font-size: var(--font-size, var(--map-h2-font-size));
  font-weight: var(--font-weight, var(--map-h2-font-weight));
  letter-spacing: var(--heading-letter-spacing);
  color: var(--h2-heading-color, var(--map-h2-color));
}

#gw-map h3.map-heading {
  font-size: var(--font-size, var(--map-h3-font-size));
  font-weight: var(--font-weight, var(--map-h3-font-weight));
  letter-spacing: var(--heading-letter-spacing);
  color: var(--h3-heading-color, var(--map-h3-color));
}

#gw-map p.map-body,
#gw-map span.map-body {
  font-family: var(--map-body-font);
  font-size: var(--font-size, var(--map-body-font-size));
  color: var(--body-text-color, var(--map-body-color));
}

#gw-map p,
#gw-map span {
  font-family: var(--map-body-font);
  color: var(--body-text-color, var(--map-body-color));
}

#gw-map p {
  margin-top: 0.5rem;
}

#gw-map p + p {
  margin-top: 1rem;
}

#gw-map p.map-body a,
#gw-map p.map-body a:visited,
#gw-map p.map-body a:active,
#gw-map span.map-body a,
#gw-map span.map-body a:visited,
#gw-map span.map-body a:active {
  color: var(--a-color, var(--map-a-color));
  text-decoration: underline;
}

#gw-map p strong,
#gw-map span strong {
  font-weight: 700;
}

#gw-map p em,
#gw-map span em {
  font-style: italic;
}

#gw-map em {
  font-style: italic;
}

#gw-map {
  height: 100%;
}

#gw-map img {
  max-width: unset;
}

#gw-map svg {
  overflow: visible;
}

.closeTextButton {
  all: unset;
  color: var(--accent-color, var(--map-accent-color));
  cursor: pointer;
  margin-top: 0.5em;
  font-family: var(--map-body-font);
  font-size: var(--map-sub-body-font-size);
  font-weight: 700;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../core/assets/main.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,eAAe;AACjB;;AAEA,2BAA2B;;AAE3B;EACE,uBAAuB;EACvB,4DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4DAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;mBACiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;mBACiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;mBACiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;mBACiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qDAAqD;EACrD,uDAAuD;;EAEvD,gEAAgE;EAChE,6DAA6D;EAC7D,gEAAgE;EAChE,+DAA+D;EAC/D,mEAAmE;EACnE,gEAAgE;;EAEhE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;;EAElC,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;EAC3B,gCAAgC;;EAEhC,sBAAsB;;EAEtB,gCAAgC;;EAEhC,yBAAyB;EACzB,qDAAqD;;EAErD,WAAW;EACX,qCAAqC;EACrC,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,qDAAqD;EACrD,gEAAgE;EAChE,sDAAsD;EACtD,qDAAqD;;EAErD,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;;EAE5B,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;;EAEnC,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;;EAElC,wBAAwB;EACxB,gDAAgD;EAChD,uDAAuD;EACvD;;;;;;GAMC;AACH;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;EAME,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,6CAA6C;EAC7C,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,0DAA0D;EAC1D,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA;EACE,oDAAoD;EACpD,0DAA0D;EAC1D,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA;;EAEE,iCAAiC;EACjC,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA;;EAEE,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mDAAmD;EACnD,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* Optional: keep global base font if desired app-wide */\r\nhtml {\r\n  font-size: 12px;\r\n}\r\n\r\n/* Font face declarations */\r\n\r\n@font-face {\r\n  font-family: \"Rajdhani\";\r\n  src: url(\"./fonts/rajdhani/rajdhani-latin-ext-300.woff2\") format(\"woff2\");\r\n  font-weight: 300;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Rajdhani\";\r\n  src: url(\"./fonts/rajdhani/rajdhani-latin-ext-regular.woff2\") format(\"woff2\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Rajdhani\";\r\n  src: url(\"./fonts/rajdhani/rajdhani-latin-ext-500.woff2\") format(\"woff2\");\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Rajdhani\";\r\n  src: url(\"./fonts/rajdhani/rajdhani-latin-ext-600.woff2\") format(\"woff2\");\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Rajdhani\";\r\n  src: url(\"./fonts/rajdhani/rajdhani-latin-ext-700.woff2\") format(\"woff2\");\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Source Sans 3\";\r\n  src: url(\"./fonts/source-sans/source-sans-3-latin-ext-regular.woff2\")\r\n    format(\"woff2\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Source Sans 3\";\r\n  src: url(\"./fonts/source-sans/source-sans-3-latin-ext-italic.woff2\")\r\n    format(\"woff2\");\r\n  font-weight: 400;\r\n  font-style: italic;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Source Sans 3\";\r\n  src: url(\"./fonts/source-sans/source-sans-3-latin-ext-700.woff2\")\r\n    format(\"woff2\");\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Source Sans 3\";\r\n  src: url(\"./fonts/source-sans/source-sans-3-latin-ext-700-italic.woff2\")\r\n    format(\"woff2\");\r\n  font-weight: 700;\r\n  font-style: italic;\r\n  font-display: swap;\r\n}\r\n\r\n#gw-map {\r\n  /* Fonts */\r\n  --map-heading-font: \"Rajdhani\", system-ui, sans-serif;\r\n  --map-body-font: \"Source Sans 3\", system-ui, sans-serif;\r\n\r\n  --map-h1-font-size: clamp(1.25rem, 1.0455rem + 1.0227vw, 3.5rem);\r\n  --map-h2-font-size: clamp(1.5rem, 1.9545rem + 0.2273vw, 2rem);\r\n  --map-h3-font-size: clamp(1.25rem, 1.7273rem + 0.1136vw, 1.5rem);\r\n  --map-body-font-size: clamp(1rem, 0.9545rem + 0.2273vw, 1.5rem);\r\n  --map-small-body-font-size: calc(var(--map-body-font-size) * 0.875);\r\n  --map-sub-body-font-size: calc(var(--map-body-font-size) * 0.75);\r\n\r\n  --map-h1-font-weight: 700;\r\n  --map-h2-font-weight: 600;\r\n  --map-h3-font-weight: 400;\r\n\r\n  /* Colours */\r\n  --map-h1-color: #060a23;\r\n  --map-h2-color: #060a23;\r\n  --map-h3-color: #333333;\r\n  --map-body-color: #333333;\r\n  --map-body-color-light: #ffffff;\r\n  --map-subtitle-color-light: #cccccc;\r\n  --map-subtitle-color-dark: #666666;\r\n\r\n  --map-background-color-light: #eeeffc;\r\n  --map-background-color-dark: #111003;\r\n  --map-accent-color: #00c49a;\r\n  --map-accent-color-dark: #00A380;\r\n\r\n  --map-a-color: #102b5e;\r\n\r\n  --heading-letter-spacing: 0.05em;\r\n\r\n  /* Map floating buttons */\r\n  --map-button-box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\r\n\r\n  /* popups */\r\n  --map-popup-background-color: #eeeffc;\r\n  --map-popup-border: 0.125rem solid #333;\r\n  --map-popup-border-color: #333;\r\n  --map-popup-border-radius: 0.75rem;\r\n  --map-popup-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.25);\r\n  --map-popup-box-shadow-inner: inset 0 0px 5px rgba(0, 0, 0, 0.5);\r\n  --map-popup-content-padding: 0.5rem 1rem 0.625rem 1rem;\r\n  --map-popup-content-padding--scrollable: 0 0 0 0 1rem;\r\n\r\n  /* icons */\r\n  --default-icon-color: #333333;\r\n  --map-icon-color-dark: #333333;\r\n  --map-icon-color-light: #cccccc;\r\n  --active-icon-color: #4cbe23;\r\n\r\n  /* Animal Status */\r\n  --status-active-color: #4cbe23;\r\n  --status-inactive-color: #ffc60a;\r\n  --status-deactivated-color: #b63e4e;\r\n\r\n  /* interactivity */\r\n  --focus-outline: 2px solid #a8bef0;\r\n  --hover-transition-duration: 0.25s;\r\n\r\n  /* Decorative elements */\r\n  --border-divider: 3px double rgba(0, 0, 0, 0.15);\r\n  --accent-border: 0.125rem solid var(--map-accent-color);\r\n  --ocean-gradient: linear-gradient(\r\n    135deg,\r\n    #060a23 0%,\r\n    #060a23 75%,\r\n    #0a0e2c 90%,\r\n    #0e1235 100%\r\n  );\r\n}\r\n\r\n#gw-map {\r\n  background: #102b5e;\r\n  overflow-y: hidden;\r\n}\r\n\r\n#gw-map :where(h1, h2, h3, h4, h5, h6, p) {\r\n  margin: 0;\r\n  line-height: 1.2;\r\n}\r\n\r\n#gw-map h1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-family: var(--map-heading-font);\r\n  letter-spacing: var(--heading-letter-spacing);\r\n}\r\n\r\n#gw-map .map-heading {\r\n  font-family: var(--map-heading-font);\r\n}\r\n\r\n#gw-map h1.mapTitle {\r\n  font-family: var(--map-heading-font);\r\n  font-size: var(--map-h1-font-size);\r\n  letter-spacing: var(--heading-letter-spacing);\r\n  font-weight: var(--map-h1-font-weight);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n#gw-map h1.map-heading {\r\n  font-size: var(--map-h1-font-size);\r\n  font-weight: var(--map-h1-font-weight);\r\n  letter-spacing: var(--heading-letter-spacing);\r\n  color: var(--map-h1-color);\r\n}\r\n\r\n#gw-map h2.map-heading {\r\n  font-size: var(--font-size, var(--map-h2-font-size));\r\n  font-weight: var(--font-weight, var(--map-h2-font-weight));\r\n  letter-spacing: var(--heading-letter-spacing);\r\n  color: var(--h2-heading-color, var(--map-h2-color));\r\n}\r\n\r\n#gw-map h3.map-heading {\r\n  font-size: var(--font-size, var(--map-h3-font-size));\r\n  font-weight: var(--font-weight, var(--map-h3-font-weight));\r\n  letter-spacing: var(--heading-letter-spacing);\r\n  color: var(--h3-heading-color, var(--map-h3-color));\r\n}\r\n\r\n#gw-map p.map-body,\r\n#gw-map span.map-body {\r\n  font-family: var(--map-body-font);\r\n  font-size: var(--font-size, var(--map-body-font-size));\r\n  color: var(--body-text-color, var(--map-body-color));\r\n}\r\n\r\n#gw-map p,\r\n#gw-map span {\r\n  font-family: var(--map-body-font);\r\n  color: var(--body-text-color, var(--map-body-color));\r\n}\r\n\r\n#gw-map p {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n#gw-map p + p {\r\n  margin-top: 1rem;\r\n}\r\n\r\n#gw-map p.map-body a,\r\n#gw-map p.map-body a:visited,\r\n#gw-map p.map-body a:active,\r\n#gw-map span.map-body a,\r\n#gw-map span.map-body a:visited,\r\n#gw-map span.map-body a:active {\r\n  color: var(--a-color, var(--map-a-color));\r\n  text-decoration: underline;\r\n}\r\n\r\n#gw-map p strong,\r\n#gw-map span strong {\r\n  font-weight: 700;\r\n}\r\n\r\n#gw-map p em,\r\n#gw-map span em {\r\n  font-style: italic;\r\n}\r\n\r\n#gw-map em {\r\n  font-style: italic;\r\n}\r\n\r\n#gw-map {\r\n  height: 100%;\r\n}\r\n\r\n#gw-map img {\r\n  max-width: unset;\r\n}\r\n\r\n#gw-map svg {\r\n  overflow: visible;\r\n}\r\n\r\n.closeTextButton {\r\n  all: unset;\r\n  color: var(--accent-color, var(--map-accent-color));\r\n  cursor: pointer;\r\n  margin-top: 0.5em;\r\n  font-family: var(--map-body-font);\r\n  font-size: var(--map-sub-body-font-size);\r\n  font-weight: 700;\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
